import { formatWordCapitalized } from 'src/util/formats'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'

const OutputForm = ({ selectedAction, outputValue }: { selectedAction: any; outputValue: any }) => {
  const vestedOutputKeys = ['amount', 'expiry', 'receiver', 'sender']
  const stakesOutputKeys = ['amount', 'savedReward', 'startTime']

  const outputKeys = selectedAction.name === 'vested' ? vestedOutputKeys : stakesOutputKeys

  return outputValue !== undefined && outputValue !== null ? (
    <div className="grid w-full gap-4">
      {selectedAction.name === 'vested' || selectedAction.name === 'stakes' ? (
        <>
          {outputKeys.map((key: string) => (
            <WrappedInput
              key={key}
              label={formatWordCapitalized(key)}
              placeholder={key}
              name={key}
              value={outputValue?.[key] ?? ''}
              readOnly
            />
          ))}
        </>
      ) : (
        <WrappedInput
          key={selectedAction.name}
          label="Output"
          placeholder={selectedAction.name}
          name={selectedAction.name}
          value={outputValue ?? ''}
          readOnly
        />
      )}
    </div>
  ) : null
}

export default OutputForm
